module.exports = __webpack_public_path__ + "img/contract_success.f3d3a657.png";